import React, { useContext, useEffect, useRef, useState } from 'react';

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialogNonTW';
import { CartContext } from '@/contexts/CartContext';
import { Cookie } from '@/tscapi/utils/cookie';

const shippingFeeModalStyles = `
  .sfn-modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: auto;
    border-radius: 2px;
  }

  .sfn-modal-header {
    text-align: center;
  }

  .sfn-modal-title {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    margin:0;
    outline: none;
  }

  .sfn-modal-description {
    margin-top: 0.5rem;
    text-align: center;
    color: #000;
    font-size: 16px;
  }


`;

interface ShippingFeeNoticeModalProps {
    checkoutStep: string;
}

export const ShippingFeeNoticeModal = ({ checkoutStep }: ShippingFeeNoticeModalProps) => {
    const cartContext = useContext(CartContext);
    const hasRemoteShipTo = !!cartContext?.cartData?.HasRemoteShipTo;
    const [open, setOpen] = useState(false);
    const titleRef = useRef<HTMLHeadingElement>(null);
    const previousHasRemoteShipToRef = useRef<boolean | null>(null);

    useEffect(() => {
        const cookie = new Cookie();

        if (
            (previousHasRemoteShipToRef.current === false && hasRemoteShipTo) ||
            (previousHasRemoteShipToRef.current === true && !hasRemoteShipTo)
        ) {
            cookie.deleteShippingFeeNoticeSeen();
        }
        previousHasRemoteShipToRef.current = hasRemoteShipTo;

        if (!hasRemoteShipTo) {
            setOpen(false);
            return;
        }

        const isAuthenticated =
            cookie.UserAccessToken != null &&
            cookie.UserAccessToken.Token?.length > 0 &&
            cookie.UserAccessToken.Edp > 0;

        // Guest: show on Step 2 (payment). Logged-in: show on Order Review (checkoutStep === '').
        const isTargetStep = checkoutStep === '' || checkoutStep === 'payment';
        if (isTargetStep && !cookie.ShippingFeeNoticeSeen && hasRemoteShipTo) {
            cookie.ShippingFeeNoticeSeen = true;
            setOpen(true);
        }
    }, [checkoutStep, hasRemoteShipTo]);

    return (
        <>
            <style>{shippingFeeModalStyles}</style>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent
                    className="sfn-modal-content"
                    onOpenAutoFocus={(e) => {
                        e.preventDefault();
                        titleRef.current?.focus();
                    }}
                >
                    <DialogHeader className="sfn-modal-header">
                        <DialogTitle className="sfn-modal-title" ref={titleRef} tabIndex={-1}>
                            Shipping Fee Notice
                        </DialogTitle>
                        <DialogDescription className="sfn-modal-description">
                            Based on your delivery location, you will be charged additional shipping fees. Check your
                            order summary section for the final amount.{' '}
                            <a
                                href="/pages/customer-service/shipping-handling"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#000', textDecoration: 'underline' }}
                            >
                                Learn more
                            </a>
                        </DialogDescription>
                    </DialogHeader>
                    {/* <DialogFooter>
                        <Button type="button" aria-label="Ok" className="w-full" onClick={() => setOpen(false)}>
                            Ok
                        </Button>
                    </DialogFooter> */}
                </DialogContent>
            </Dialog>
        </>
    );
};
